import { useEffect, useState } from 'react'
import { message } from 'antd'
import { handleError } from '../../../lib/utils'
import { readClinics, updateClinic } from '../../clinics/utils/utils'
import { MedPraxSchemeSearch, updateBillingProfile } from '../utils'

const useBillingProfile = ({
  clinicRef,
  targetForm,
  setRecordData,
  initialValuesControl,
  setInitialValuesControl,
  newRecord
}) => {
  const [clinicsLoading, setClinicsLoading] = useState(false)
  const [schemesLoading, setSchemesLoading] = useState(false)
  const [schemeOps, setSchemeOps] = useState([])
  const [clinics, setClinics] = useState([])
  const [selectedClinic, setSelectedClinic] = useState(clinicRef || null)
  const [unsavedChanges, setUnsavedChanges] = useState(false)

  const handleFacilityChange = (clinicId) => {
    setSelectedClinic(clinicId)
  }

  useEffect(() => {
    // ======== STANDALONE PAGE FORM EXCEPTION ======== //
    // This is used when the billing profile is opened as a standalone page
    // We need to go fetch the clinics data so that we can select a clinic as the data is not being passed from an existing clinic Form
    if (!clinicRef) {
      handleGetClinics()
    }
    // ======== STANDALONE PAGE FORM EXCEPTION ======== //
    handleGetSchemes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ======== STANDALONE PAGE FORM EXCEPTION ======== //
  // This is used when the billing profile is opened as a standalone page
  // We need to go fetch the clinics data so that we can select a clinic as the data is not being passed from an existing clinic Form

  useEffect(() => {
    if (selectedClinic && !clinicRef && !newRecord) {
      targetForm.resetFields()
      setInitialValuesControl(null)
      handleGetData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClinic])

  const handleGetClinics = async () => {
    setClinicsLoading(true)
    try {
      const response = await readClinics({ isActive: true })
      setClinics(response)
    } catch (e) {
      message.error(handleError(e, true))
    }
    setClinicsLoading(false)
  }

  const clinicOptions = () => {
    return clinics.map((clinic) => ({
      label: `${clinic.name} - ${clinic.address || 'No address provided'}`,
      value: clinic._id,
      clinic: clinic
    }))
  }

  const handleGetData = async () => {
    try {
      const filter = { _id: selectedClinic }
      const response = await readClinics(filter, false, 'billingProfile')
      targetForm.setFieldsValue(response[0].billingProfile)
      setInitialValuesControl(response[0].billingProfile)
    } catch (e) {
      message.error(handleError(e, true))
    }
  }

  // ======== STANDALONE PAGE FORM EXCEPTION ======== //

  const handleGetSchemes = async (page = 1) => {
    let response = []
    let tmpOps = []

    setSchemesLoading(true)

    try {
      response = await MedPraxSchemeSearch('', page)
      tmpOps = response.schemes.pageResult

      if (page < response.schemes.totalPages) {
        handleGetSchemes(page + 1)
      }

      setSchemeOps((prev) => [...prev, ...tmpOps])
    } catch (e) {
      message.error(handleError(e, true))
    }

    setSchemesLoading(false)
  }

  // Save billing profile
  const standaloneFormSubmit = async () => {
    if (!selectedClinic) {
      message.error('Please select a facility first')
      return
    }
    try {
      const formValues = targetForm.getFieldsValue()
      const payload = { billingProfile: { ...formValues } }

      await updateClinic({ _id: selectedClinic, ...payload })
      setUnsavedChanges(false)
      message.success('Facility billing profile saved successfully')
    } catch (e) {
      message.error(handleError(e, true))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }

  return {
    clinicsLoading,
    schemesLoading,
    schemeOps,
    clinics,
    selectedClinic,
    clinicOptions: clinicOptions(),
    handleFacilityChange,
    standaloneFormSubmit,
    unsavedChanges,
    setUnsavedChanges
  }
}

export default useBillingProfile
